import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class CorporateService {

 constructor(private ws: PostmethodService) { }

  corporateCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "corporatesMaster");
  }
}
